import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role, RoleChange, RoleFormValue, RoleResponse } from '../types/role.types';

@Injectable({ providedIn: 'root' })
export class RoleApiService {
  private http = inject(HttpClient);
  private base = 'role';

  getRole(id: number): Observable<RoleResponse> {
    return this.http.get<RoleResponse>(`${this.base}/${id}`, {
      params: { include: ['allPermissions', 'selectedPermissions'] }
    });
  }

  createRole(value: RoleFormValue): Observable<RoleResponse> {
    return this.http.post<RoleResponse>(this.base, value);
  }

  updateRole(id: number, value: RoleFormValue): Observable<RoleResponse> {
    return this.http.put<RoleResponse>(`${this.base}/${id}`, value);
  }

  updatePermissions(id: number, permissionIds: number[]): Observable<void> {
    return this.http.put<void>(`${this.base}/permissions/${id}`, permissionIds);
  }

  updateUserRole(id: number, change: RoleChange): Observable<any> {
    return this.http.put<any>(`${this.base}/assign/${id}`, change);
  }

  // This is by tenant
  getAllRoles(): Observable<Partial<Role>[]> {
    return this.http.get<Partial<Role>[]>(`${this.base}/assignable`);
  }
}
